/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioItemFiltersSchema = z.object({
  estimationIds: z.array(z.int()).nullish(),
  itemStatusIds: z.array(z.int()).nullish(),
  itemTypeIds: z.array(z.int()).nullish(),
  mlimputed: z.boolean(),
  needsTeamOrEstimate: z.boolean(),
  noTeamSet: z.boolean(),
  searchText: z.string().min(0).max(50).nullish(),
  teamIds: z.array(z.int()).nullish(),
  unparented: z.boolean(),
});
